import userLoggedOutLogo from "@assets/user/Logged_Out.svg";
import { ReactElement } from "react";

export type ScrolledHeaderLoginButtonProps = {
  initialLogin: () => void;
};

export function ScrolledHeaderLoginButton({
  initialLogin,
}: ScrolledHeaderLoginButtonProps): ReactElement {
  return (
    <>
      <button type="button" title="Login" onClick={initialLogin}>
        <img
          width={32}
          height={32}
          src={userLoggedOutLogo}
          alt="login"
          loading="lazy"
        />
      </button>
    </>
  );
}
